/**
 * Template: Partnerships custom template
 * -----------------------------------------------------------------------------
 * Scripts to execute on the partnerships page.
 *
 */
import {load} from '@shopify/theme-sections';
import '../../styles/templates/page.partnerships.scss';


import FeatureCarousel from '~/components/feature-carousel';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
  FeatureCarousel().init();
});
